import apiService from '@/services/apiService';

const actions = {
  getSpecialVouchersWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/special/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSpecialVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`promo/voucher/special/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postSpecialVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher/special', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putSpecialVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`promo/voucher/special/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteSpecialVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`promo/voucher/special/delete/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  changeOrderSpecialVoucher({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`promo/voucher/special/change-order/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;